import React from 'react'
import useSurveyForm from './useSurveyForm'
import { View } from 'react-native'
import { FormProvider } from 'react-hook-form'
import Button from '@ui/buttons/Button'
import FormRadio from '@ui/forms/Radio/FormRadio'
import { useTranslation } from 'react-i18next'
import Typography from '@ui/typography'

const RadioGroup = ({
  label,
  name,
  options,
  disabled,
}: {
  label: string
  name: string
  options: { label: string; value: string }[]
  disabled?: boolean
}) => {
  return (
    <View className="flex flex-col gap-2">
      <Typography className="pb-2 text-black/50" variant="MDB">
        {label}
      </Typography>
      <View className="flex-col gap-2">
        {options.map((option) => (
          <FormRadio
            key={option.value}
            name={name}
            value={option.value}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </View>
    </View>
  )
}

const Survey = ({
  questions,
  form,
  isPending,
  onSubmit,
}: ReturnType<typeof useSurveyForm>) => {
  const { t } = useTranslation(['ui', 'survey'])

  return (
    <View className="gap-8">
      <FormProvider {...form}>
        <View className="flex flex-col gap-6">
          {questions?.map((question) => (
            <View key={question.code} className="border-b border-black/10 pb-6">
              <RadioGroup
                name={question.code}
                disabled={isPending}
                label={t(`survey:questions.${question.code}.label`)}
                options={question.answers.map((answer) => ({
                  label: t(`survey:answers.${answer}`),
                  value: answer,
                }))}
              />
            </View>
          ))}
        </View>
      </FormProvider>
      <View className="w-max self-start">
        <Button
          variant="outlined"
          label={t('ui:save')}
          loading={isPending}
          onPress={onSubmit}
        />
      </View>
    </View>
  )
}

export default Survey
